<template>
    <nuxt-link :to="shortcut.uri" class="text-decoration-none">
        <CardContainer class="contact-us-shortcut" no-header no-footer body-class="p-24">
            <template #body>
                <div class="text-color primary">
                    <Heading
                        color="primary"
                        class="font-bold mb-2"
                        tag="p"
                        size="web-xx-sm"
                        font="font-roboto"
                        style="letter-spacing: -0.5px;"
                    >
                        {{ shortcut.heading }}
                    </Heading>

                    <Texture
                        size="md"
                        color="accent-2nd"
                        class="flex items-center font-medium m-0 font-manrope"
                    >
                        {{ shortcut.description }} <UIcon name="i-pkg-navigation-chevron-rightcompact" class="size-6" />
                    </Texture>
                </div>
            </template>
        </CardContainer>
    </nuxt-link>
</template>

<script>
import CardContainer from '~/components/xerneas/Card/CardContainer.vue';
import Heading from '~/components/xerneas/Heading/Heading.vue';
import Texture from '~/components/xerneas/Text/Texture.vue';

export default {
    components: {
        CardContainer,
        Heading,
        Texture,
    },
    props: {
        shortcut: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss">
.contact-us-shortcut {
    .card-body {
        text-align: left;
        padding: 24px !important;
    }
}
</style>
